// Helpers
import {
  CampaignOfferStatus,
  CampaignTaskType,
  CbDeliverableV2Status,
} from 'api/graphql-global-types';
import { formatDate } from 'helpers/tipsHelper';
// Ui
import { Step } from 'ui3/Stepper/Stepper';

export enum CampaignVersion {
  V1 = '1',
  V2 = '2',
  V3 = '3',
}

export const DELIVERABLES_CHECKLIST_APPROVAL_STEP = (dueDate: Date): Step[] => [
  {
    number: 1,
    name: 'Brand Review',
    description: `The brand is reviewing your application and has until ${formatDate(
      dueDate
    )} to respond.`,
  },
  {
    number: 2,
    name: 'Submit Content For Review',
    description:
      "If approved, you'll be given the go-ahead to create content deliverables for brand to review.",
  },
  {
    number: 3,
    name: 'Post Deliverables',
    description:
      "Once content is approved, you'll be able to post your content per the details and get paid!",
  },
];

export const DELIVERABLES_TIMELINE_CARDS_MAX_SLOTS = 2;
export const POST_DELIVERABLE_LINK_TYPES = [
  CampaignTaskType.IG_POST,
  CampaignTaskType.IG_REEL,
  CampaignTaskType.TT_VIDEO,
  CampaignTaskType.TW_TWEET,
  CampaignTaskType.TW_VIDEO,
  CampaignTaskType.TW_LIVE,
];
export const DONE_DELIVERABLE_STATUSES = [
  CbDeliverableV2Status.CONTENT_APPROVED,
  CbDeliverableV2Status.ON_BRAND_REVIEW,
  CbDeliverableV2Status.PUBLISHED,
];
// Most of these won't be other than accepted, because attention won't be present for other statuses
export const IN_PROGRESS_OFFER_STATUSES = [
  CampaignOfferStatus.ACCEPTED,
  CampaignOfferStatus.SUBMITTED,
  CampaignOfferStatus.DELIVERABLES_APPROVED,
];

// Max story-insight screenshots an athlete can attach to a social boost proof
export const MAX_PROOF_SCREENSHOTS = 50;
